import { localeCodeMap } from './constants'
import enUs from './translations/en-us.json'
import jaJp from './translations/ja-jp.json'

export type TranslationSchema = typeof enUs & typeof jaJp

export const resources: {
  [key: string]: {
    translation: TranslationSchema
  }
} = {
  [localeCodeMap.jaJp]: {
    translation: jaJp,
  },
  [localeCodeMap.enUs]: {
    translation: enUs,
  },
}
